import IconMessengerSkype from '@/assets/images/icons/messengers/skype-color.svg';
import IconMessengerViber from '@/assets/images/icons/messengers/viber-color.svg';
import IconMessengerWhatsApp from '@/assets/images/icons/messengers/whatsapp-color.svg';
import IconMessengerTelegram from '@/assets/images/icons/messengers/telegram-color.svg';
import IconMessengerYandex from '@/assets/images/icons/messengers/yandex-color.svg';

export const MESSENGERS = {
  SKYPE: 'Skype',
  VIBER: 'Viber',
  WHATS_APP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  YANDEX: 'Yandex',
};

export const MESSENGER_ICONS = {
  [MESSENGERS.SKYPE]: IconMessengerSkype,
  [MESSENGERS.VIBER]: IconMessengerViber,
  [MESSENGERS.WHATS_APP]: IconMessengerWhatsApp,
  [MESSENGERS.TELEGRAM]: IconMessengerTelegram,
  [MESSENGERS.YANDEX]: IconMessengerYandex,
};

export const getMessengerIcon = (name) => MESSENGER_ICONS[name];

export const MESSENGER_ICONS_BY_ID = {
  0: IconMessengerSkype,
  1: IconMessengerViber,
  2: IconMessengerWhatsApp,
  3: IconMessengerTelegram,
  4: IconMessengerYandex,
};

export const getMessengerIconById = (id) => MESSENGER_ICONS_BY_ID[id];
